/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.SaleProgram {
    angular.module("meevo.plugins.saleProgram", []);
}